import { render } from "./OrderHelper.vue?vue&type=template&id=743ab98a&scoped=true"
import script from "./OrderHelper.vue?vue&type=script&lang=js"
export * from "./OrderHelper.vue?vue&type=script&lang=js"

import "./OrderHelper.vue?vue&type=style&index=0&id=743ab98a&scoped=true&lang=less"

import exportComponent from "F:\\handzone_game\\10001-sdk\\web\\hzgamebox\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-743ab98a"]])

export default __exports__